import * as React from "react";

import { LocalizerContext } from "@com.mgmtp.a12.utils/utils-localization-react/lib/main";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button";
import { MessageBox } from "@com.mgmtp.a12.widgets/widgets-core/lib/message-box";

import { SmallBoxLayout } from "../../component/SmallBoxLayout";
import { RESOURCE_KEYS } from "../../localization";

const LOGOUT_RESOURCE_KEYS = RESOURCE_KEYS.application.content.logout;

export const LogoutPage: React.ComponentType = function LogoutPage() {
	const { localizer } = React.useContext(LocalizerContext);

	const onClick = React.useCallback(() => {
		window.location.assign("/");
	}, []);

	return (
		<SmallBoxLayout
			content={<MessageBox variant="success" label={localizer({ key: LOGOUT_RESOURCE_KEYS.label })} />}
			footer={
				<Button label={localizer({ key: LOGOUT_RESOURCE_KEYS.button.label })} primary block onClick={onClick} />
			}
			showApplicationBanner
			fullscreen
		/>
	);
};
